// page-character.js — full-page character detail (#/char/<id>/<tab>). Tabs: 개요 / 인벤토리 / 장비 / 스킬·버프 /
// 지도 / 사냥 설정 / 제어. Live updates via App.ws while open (header conn badge, HP, inventory, map). Developer
// telemetry is tucked into a collapsed 진단 정보 section. 사냥 설정 delegates to HuntForm.mountSlotEditor; 제어 sends
// agent commands with confirmations for disruptive ones and shows cmd_ack results. Ported from the legacy modal.
'use strict';
(function () {
  const App = window.App;
  const t = App.t;
  const esc = App.esc;

  App.i18n.add({
    ko: {
      char_tab_overview: '개요', char_tab_inventory: '인벤토리', char_tab_equipment: '장비', char_tab_skills: '스킬·버프',
      char_tab_map: '지도', char_tab_hunt: '사냥 설정', char_tab_control: '제어',
      char_load_fail: '캐릭터를 불러오지 못했습니다.', char_not_found: '캐릭터를 찾을 수 없습니다.',
      char_server: '서버', char_account: '계정', char_machine: '머신', char_slot_none: '계정 슬롯 미지정',
      char_not_collected: '미수집', char_cur_none: '없음',
      char_o_hp: 'HP', char_o_mp: 'MP', char_o_level: '레벨', char_o_map: '맵', char_o_coord: '좌표',
      char_o_stage: '스테이지', char_o_status: '상태', char_o_skillbuff: '스킬/버프', char_o_gcd: 'GCD',
      char_o_updated: '갱신', char_o_look: '외형', char_o_pk: '나를 공격 중',
      char_o_adena: '아데나',
      char_machine_hdr: '머신', char_mc_name: '머신', char_mc_cpu_pct: 'CPU', char_mc_ram: 'RAM(MB)',
      char_mc_os: 'OS', char_mc_locale: '언어', char_mc_cpu: 'CPU 종류', char_mc_cores: '코어', char_mc_ip: 'IP',
      char_stats: '스탯', char_no_stats: '스탯 데이터 없음 (에이전트 캡처 대기)',
      char_diag: '진단 정보', char_diag_hint: '개발·디버깅용 원시 데이터입니다.',
      char_o_ui: '떠있는 UI', char_o_scroll: '스크롤 위치', char_o_slots: '화면 슬롯', char_o_occl: '가려진 UI',
      char_o_world: '월드', char_occlusion_full: '완전', char_occlusion_partial: '부분', char_slots_unknown: '미수집 {0}',
      char_no_inv: '인벤토리 데이터 없음 (에이전트 캡처 대기)', char_inv_count: '아이템 {0}개',
      char_inv_image: '이미지', char_inv_list: '리스트', char_inv_tip_enchant: '강화 +{0}', char_inv_tip_qty: '수량 {0}',
      char_eq_empty: '착용 장비 없음 (장비창 데이터 대기)', char_eq_count: '착용 {0}개', char_eq_range: '무기 사거리: {0}칸',
      char_skills_hdr: '스킬 {0} · 버프 {1}', char_skills_note: '상세 스킬/버프 목록은 에이전트 캡처 확장 시 표기됩니다.',
      char_buffs_hdr: '버프 {0}', char_buffs_note: '현재 활성 버프가 없습니다.',
      char_qs_hdr: '퀵슬롯 (페이지 {0}, {1}개)', char_qs_note: '퀵슬롯 정보 없음', char_qs_item: '아이템', char_qs_behavior: '행동',
      char_buff_dur: '총 지속 {0}', char_buff_inf: '무제한 (타이머 없음)',
      char_map_centered: '맵 (현위치 중심)', char_minimap: '미니맵', char_map_wheel: '휠=줌', char_map_tiles: '{0}칸',
      char_legend: '몹=빨강 · NPC=노랑 · 타 플레이어=파랑 · 드롭=흰색 · 나=◎', char_map_none: '위치 정보가 없습니다.',
      char_k_monster: '몹', char_k_npc: 'NPC', char_k_player: '플레이어', char_k_user: '타 플레이어',
      char_k_remoteplayer: '타 플레이어', char_k_pet: '펫/소환', char_k_drop: '드롭', char_k_door: '오브젝트', char_k_unknown: '미상',
      char_ctrl_actions: '명령', char_ctrl_disruptive_note: '아래 작업은 실행 중인 게임에 즉시 적용됩니다.',
      char_ctrl_hunt: '사냥', char_ctrl_overlay: '오버레이', char_on: 'ON', char_off: 'OFF',
      char_ctrl_return: 'QA 귀환', char_ctrl_stop: 'QA 세션 종료',
      char_ctrl_play_state: 'QA 플레이 상태', char_ctrl_no_play: 'QA 플레이 상태 미수집',
      char_cmd_results: '최근 명령 결과', char_cmd_empty: '아직 명령 결과가 없습니다.',
      char_cmd_sent: '명령을 전송했습니다: {0}', char_agent_offline: '에이전트가 오프라인이라 명령이 적용되지 않았습니다.',
      char_confirm_return_title: 'QA 귀환', char_confirm_return: '지금 귀환 명령을 보내면 캐릭터가 사냥터를 떠나 안전 마을로 돌아갑니다. 계속할까요?',
      char_confirm_stop_title: 'QA 세션 종료', char_confirm_stop: '세션을 종료하면 게임이 종료되고 자동 실행이 멈춥니다. 계속할까요?',
      char_hunt_no_slot: '이 캐릭터에는 연결된 계정 슬롯이 없어 사냥 설정을 편집할 수 없습니다.',
      char_hunt_no_slot_cta: '머신에서 계정 슬롯 연결',
      char_hunt_unavailable: '사냥 설정 편집기를 불러오지 못했습니다. 잠시 후 다시 시도하세요.',
      char_ag_ingame: '인게임', char_ag_terms: '약관 동의', char_ag_server: '서버 선택', char_ag_login: '로그인',
      char_ag_charsel: '캐릭터 선택', char_ag_lobby: '로비', char_ag_unknown: '미식별', char_ag_notgoal: '대기',
      char_ag_hunting: '사냥 중', char_ag_idle: '대기', char_ag_moving: '이동 중'
    },
    'zh-CN': {
      char_tab_overview: '概览', char_tab_inventory: '背包', char_tab_equipment: '装备', char_tab_skills: '技能·增益',
      char_tab_map: '地图', char_tab_hunt: '狩猎设置', char_tab_control: '控制',
      char_load_fail: '无法加载角色。', char_not_found: '找不到角色。',
      char_server: '服务器', char_account: '账号', char_machine: '机器', char_slot_none: '未指定账号槽',
      char_not_collected: '未采集', char_cur_none: '无',
      char_o_hp: 'HP', char_o_mp: 'MP', char_o_level: '等级', char_o_map: '地图', char_o_coord: '坐标',
      char_o_stage: '阶段', char_o_status: '状态', char_o_skillbuff: '技能/增益', char_o_gcd: 'GCD',
      char_o_updated: '更新', char_o_look: '外形', char_o_pk: '正在攻击我',
      char_o_adena: '金币',
      char_machine_hdr: '机器', char_mc_name: '机器', char_mc_cpu_pct: 'CPU', char_mc_ram: '内存(MB)',
      char_mc_os: '系统', char_mc_locale: '语言', char_mc_cpu: 'CPU 型号', char_mc_cores: '核心', char_mc_ip: 'IP',
      char_stats: '属性', char_no_stats: '暂无属性数据（等待代理采集）',
      char_diag: '诊断信息', char_diag_hint: '用于开发·调试的原始数据。',
      char_o_ui: '打开的 UI', char_o_scroll: '滚动位置', char_o_slots: '画面栏位', char_o_occl: '被遮挡 UI',
      char_o_world: '世界', char_occlusion_full: '完全', char_occlusion_partial: '部分', char_slots_unknown: '未采集 {0}',
      char_no_inv: '暂无背包数据（等待代理采集）', char_inv_count: '物品 {0} 个',
      char_inv_image: '图标', char_inv_list: '列表', char_inv_tip_enchant: '强化 +{0}', char_inv_tip_qty: '数量 {0}',
      char_eq_empty: '无装备（等待装备数据）', char_eq_count: '装备 {0} 件', char_eq_range: '武器射程: {0} 格',
      char_skills_hdr: '技能 {0} · 增益 {1}', char_skills_note: '详细技能/增益列表将在代理采集扩展后显示。',
      char_buffs_hdr: '增益 {0}', char_buffs_note: '当前无激活增益。',
      char_qs_hdr: '快捷栏 (第 {0} 页, {1} 个)', char_qs_note: '无快捷栏数据', char_qs_item: '道具', char_qs_behavior: '动作',
      char_buff_dur: '总持续 {0}', char_buff_inf: '无时限（无计时器）',
      char_map_centered: '地图（以当前位置为中心）', char_minimap: '小地图', char_map_wheel: '滚轮=缩放', char_map_tiles: '{0}格',
      char_legend: '怪=红 · NPC=黄 · 其他玩家=蓝 · 掉落=白 · 我=◎', char_map_none: '暂无位置信息。',
      char_k_monster: '怪物', char_k_npc: 'NPC', char_k_player: '玩家', char_k_user: '其他玩家',
      char_k_remoteplayer: '其他玩家', char_k_pet: '宠物/召唤', char_k_drop: '掉落', char_k_door: '物件', char_k_unknown: '未知',
      char_ctrl_actions: '命令', char_ctrl_disruptive_note: '以下操作会立即作用于运行中的游戏。',
      char_ctrl_hunt: '狩猎', char_ctrl_overlay: '覆盖层', char_on: '开', char_off: '关',
      char_ctrl_return: 'QA 返回', char_ctrl_stop: 'QA 结束会话',
      char_ctrl_play_state: 'QA 运行状态', char_ctrl_no_play: '未采集 QA 运行状态',
      char_cmd_results: '最近命令结果', char_cmd_empty: '暂无命令结果。',
      char_cmd_sent: '已发送命令: {0}', char_agent_offline: '代理离线，命令未生效。',
      char_confirm_return_title: 'QA 返回', char_confirm_return: '发送返回命令后，角色将离开狩猎场返回安全村庄。确定继续吗？',
      char_confirm_stop_title: 'QA 结束会话', char_confirm_stop: '结束会话将关闭游戏并停止自动启动。确定继续吗？',
      char_hunt_no_slot: '该角色没有连接的账号槽，无法编辑狩猎设置。',
      char_hunt_no_slot_cta: '在机器中连接账号槽',
      char_hunt_unavailable: '无法加载狩猎设置编辑器，请稍后重试。',
      char_ag_ingame: '游戏中', char_ag_terms: '条款同意', char_ag_server: '选择服务器', char_ag_login: '登录',
      char_ag_charsel: '选择角色', char_ag_lobby: '大厅', char_ag_unknown: '未识别', char_ag_notgoal: '待机',
      char_ag_hunting: '狩猎中', char_ag_idle: '待机', char_ag_moving: '移动中'
    }
  });

  // ── module state / pure helpers ──
  const detailCache = new Map();        // id -> last detail payload (kept fresh by live states)
  const TABS = [
    ['overview', 'char_tab_overview'], ['inventory', 'char_tab_inventory'], ['equipment', 'char_tab_equipment'],
    ['skills', 'char_tab_skills'], ['map', 'char_tab_map'], ['hunt', 'char_tab_hunt'], ['control', 'char_tab_control']
  ];
  const TAB_KEYS = TABS.map(x => x[0]);
  const CS_TONE = { offline: 'bad', reconnecting: 'warn', bridge: 'warn', launching: 'info', ingame: 'ok' };
  const AGENT_I18N = { '인게임': 'ingame', '약관동의': 'terms', '서버선택': 'server', '로그인': 'login', '캐릭선택': 'charsel', '로비': 'lobby', '미식별': 'unknown', '목표 단계 아님': 'notgoal', '사냥중': 'hunting', '대기': 'idle', '이동': 'moving' };
  const ACTOR_COL = { monster: '#f85149', npc: '#d29922', player: '#3fb950', user: '#58a6ff', remoteplayer: '#f778ba', drop: '#e6edf3', door: '#8b949e', pet: '#a371f7' };

  function isOffline(c) { return (c.online === false) || (c.online == null && Date.now() - (c.updated_at || 0) > 30000); }
  function connBadge(c) {
    const s = c.conn_stage || (isOffline(c) ? 'offline' : 'ingame');
    if (s === 'ingame') return `<span class="badge ok">${esc(t('dash_cs_ingame'))}</span>`;
    const tone = CS_TONE[s] || 'neutral';
    return `<span class="badge ${tone}">${esc(t('dash_cs_' + s))}</span>`;
  }
  function agentLabel(s) { if (s == null || s === '') return ''; const k = AGENT_I18N[String(s).trim()]; return k ? t('char_ag_' + k) : String(s); }
  function kindLabel(k) { return t('char_k_' + (k || 'unknown')); }

  function invTooltip(it, nm) {
    const p = [nm];
    if (it.enchant) p.push(t('char_inv_tip_enchant', it.enchant));
    if (it.qty > 1) p.push(t('char_inv_tip_qty', it.qty));
    if (it.code != null) p.push('#' + it.code);
    return p.join('\n');
  }
  function invCell(it) {
    const nm = App.cat.itemDisplay(it);
    const sty = App.cat.itemIcon(it.code);
    const ico = sty ? `<span class="ic" style="${sty}"></span>` : `<span class="ic noimg">${esc(String(nm).slice(0, 4))}</span>`;
    return `<div class="invc" data-tip="${esc(invTooltip(it, nm))}">${ico}` +
      `${it.enchant ? '<span class="e">+' + esc(it.enchant) + '</span>' : ''}${it.qty > 1 ? '<span class="q">' + esc(it.qty) + '</span>' : ''}` +
      `<div class="nm">${esc(nm)}</div></div>`;
  }
  function invRow(it) {
    const nm = App.cat.itemDisplay(it);
    const sty = App.cat.itemIcon(it.code);
    const ico = sty ? `<span class="ic sm" style="${sty}"></span>` : `<span class="ic sm noimg">·</span>`;
    return `<div class="invr" data-tip="${esc(invTooltip(it, nm))}">${ico}<span class="rn">${it.enchant ? '+' + esc(it.enchant) + ' ' : ''}${esc(nm)}</span><span class="rq">${it.qty > 1 ? 'x' + esc(it.qty) : ''}</span></div>`;
  }

  function loadInvMode() { try { return localStorage.getItem('char.invMode') === 'list' ? 'list' : 'image'; } catch (_) { return 'image'; } }
  function saveInvMode(m) { try { localStorage.setItem('char.invMode', m); } catch (_) {} }

  // Shared hover tooltip (inventory cells + map canvas). Wired once.
  let tipWired = false;
  function ensureTip() {
    if (!document.getElementById('invtip')) {
      const tp = document.createElement('div'); tp.id = 'invtip'; tp.className = 'tooltip'; tp.style.display = 'none'; document.body.appendChild(tp);
    }
    if (tipWired) return; tipWired = true;
    const tipEl = () => document.getElementById('invtip');
    document.addEventListener('mouseover', (e) => { const el = e.target.closest && e.target.closest('[data-tip]'); const tp = tipEl(); if (!el || !tp) return; tp.textContent = el.getAttribute('data-tip'); tp.style.display = 'block'; });
    document.addEventListener('mousemove', (e) => { const tp = tipEl(); if (!tp || tp.style.display === 'none') return; if (e.target && e.target._hits) return; const el = e.target.closest && e.target.closest('[data-tip]'); if (!el) { tp.style.display = 'none'; return; } tp.style.left = Math.min(window.innerWidth - tp.offsetWidth - 8, e.clientX + 14) + 'px'; tp.style.top = (e.clientY + 16) + 'px'; });
    document.addEventListener('mouseout', (e) => { const el = e.target.closest && e.target.closest('[data-tip]'); if (el) { const tp = tipEl(); if (tp) tp.style.display = 'none'; } });
  }

  App.page('char', {
    title: () => t('nav_dashboard'),
    navAs: 'dashboard',
    render(root, params) {
      const id = Number(params[0]);
      let tab = params[1] || 'overview';
      if (!TAB_KEYS.includes(tab)) tab = 'overview';
      if (!Number.isInteger(id)) {
        root.innerHTML = `<div class="page char"><div class="empty-state"><div class="empty-icon">❓</div><p>${esc(t('char_not_found'))}</p><a class="btn secondary" href="#/">${esc(t('nav_dashboard'))}</a></div></div>`;
        return;
      }
      ensureTip();

      const st = { id, tab, data: detailCache.get(id) || null, huntMount: null, destroyed: false, mapZoom: 20, invMode: loadInvMode(), gridImgs: {}, isoImgs: {} };

      root.innerHTML = `<div class="page char">
        <div class="char-head" id="charHead"></div>
        <div class="tabs" id="charTabs">${TABS.map(([k, lk]) => `<a class="tab${k === st.tab ? ' on' : ''}" href="#/char/${st.id}/${k}" data-tab="${k}">${esc(t(lk))}</a>`).join('')}</div>
        <div class="char-body" id="charBody"></div>
      </div>`;
      const headEl = root.querySelector('#charHead');
      const bodyEl = root.querySelector('#charBody');

      // ── header ──
      function drawHeader() {
        const d = st.data, c = (d && d.character) || {}, slot = (d && d.slot) || null;
        const machineLabel = c.machine_label || c.machine || (slot && slot.machine_label) || '';
        const acct = (slot && slot.game_account) || c.game_account || '';
        const server = c.server_name || (slot && slot.server_name) || '';
        const lic = (slot && slot.license) || c.license || null;
        document.title = (c.name ? c.name + ' · ' : '') + t('brand');
        headEl.innerHTML = `
          <div class="row nowrap"><a class="btn ghost sm" href="#/">← ${esc(t('nav_dashboard'))}</a></div>
          <div class="char-title">
            <h1 class="truncate">${esc(c.name || ('#' + st.id))}</h1>
            <div class="char-badges"><span class="badge neutral">${esc(t('dash_lv', c.level || 0))}</span><span id="charConn">${connBadge(c)}</span>${App.licenseBadge(lic)}</div>
          </div>
          <div class="char-sub small muted">
            ${server ? `<span>${esc(t('char_server'))}: ${esc(server)}</span>` : ''}
            ${acct ? `<span>${esc(t('char_account'))}: ${esc(acct)}</span>` : ''}
            ${machineLabel ? `<span>${esc(t('char_machine'))}: ${esc(machineLabel)}</span>` : `<span>${esc(t('char_slot_none'))}</span>`}
          </div>`;
      }
      function headerSkeleton() {
        headEl.innerHTML = `<div class="row nowrap"><a class="btn ghost sm" href="#/">← ${esc(t('nav_dashboard'))}</a></div>
          <div class="char-title"><span class="skeleton" style="width:220px;height:24px"></span></div>
          <div class="char-badges"><span class="skeleton" style="width:60px;height:20px"></span><span class="skeleton" style="width:80px;height:20px"></span></div>`;
      }
      function bodySkeleton() {
        bodyEl.innerHTML = `<div class="section"><div class="kv-grid">${Array.from({ length: 8 }).map(() => `<div class="kv-item"><span class="skeleton" style="width:60%;height:11px"></span><span class="skeleton" style="width:80%;height:14px;margin-top:6px"></span></div>`).join('')}</div></div>`;
      }

      // ── tab renderers ──
      function tabOverview(d, c, el) {
        const mi = d.machine_info || {};
        const NC = t('char_not_collected');
        const unavailable = (d.raw && d.raw.unavailable) || [];
        const missing = (k) => c[k] == null || unavailable.includes(k);
        const val = (v, suf) => v == null ? NC : String(v) + (suf || '');
        const kv = (k, v) => `<div class="kv-item"><div class="k">${esc(k)}</div><div class="v">${esc(v)}</div></div>`;
        const me = (d.nearby || []).find(n => n.kind === 'player');
        const look = me && me.spr != null ? App.cat.spriteThumb(me.spr, 48) + ` <small class="muted">#${esc(me.spr)}</small>` : esc(NC);
        const pk = (d.nearby || []).filter(n => n.atk_me);
        const pkHtml = pk.length ? pk.map(n => `<span class="sprchip">${App.cat.spriteThumb(n.spr, 28)}${esc((n.name || '') + ' (' + kindLabel(n.kind) + ')')}</span>`).join('') : '—';
        const stats = d.stats || {}; const statKeys = Object.keys(stats);
        const uiList = missing('ui_list') ? NC : ((c.ui_list || []).join(', ') || t('char_cur_none'));
        const scrolls = missing('scrolls') ? NC : (((c.scrolls || []).map(x => (x.w ? x.w + '/' : '') + x.n + ': ' + [x.v >= 0 ? 'Y ' + x.v.toFixed(1) + '%' : '', x.h >= 0 ? 'X ' + x.h.toFixed(1) + '%' : ''].filter(Boolean).join(' / ')).join(', ')) || t('char_cur_none'));
        const slots = missing('ui_slots') ? NC : ((() => { const g = {}; for (const x of (c.ui_slots || [])) { const k = x.w || '-'; g[k] = g[k] || [0, 0, 0]; g[k][1]++; if ((x.id != null && x.id !== -1) || x.text || x.occupied === true) g[k][0]++; else if (x.id == null) g[k][2]++; } return Object.entries(g).map(([w, v]) => w + ': ' + v[0] + '/' + v[1] + (v[2] ? ' (' + t('char_slots_unknown', v[2]) + ')' : '')).join(', '); })() || t('char_cur_none'));
        const occl = missing('ui_occl') ? NC : (((c.ui_occl || []).map(o => (o.world ? t('char_o_world') + ': ' : '') + '[' + t(o.full ? 'char_occlusion_full' : 'char_occlusion_partial') + '] ' + o.n + ' ← ' + o.by).join(', ')) || t('char_cur_none'));
        el.innerHTML = `
          ${App.supplyShortBanner(c.supply_short || (d.raw && d.raw.play && d.raw.play.supply_short))}
          <div class="section">
            <div class="kv-grid">
              ${kv(t('char_o_hp'), val(c.hp) + ' / ' + val(c.max_hp))}
              ${kv(t('char_o_mp'), val(c.mp) + ' / ' + val(c.max_mp))}
              ${kv(t('char_o_level'), val(c.level))}
              ${kv(t('char_o_map'), missing('map_id') ? NC : App.cat.mapLabel({ map_id: c.map_id, x: c.x, y: c.y }))}
              ${kv(t('char_o_coord'), '(' + val(c.x) + ', ' + val(c.y) + ')')}
              ${kv(t('char_o_stage'), agentLabel(c.stage) || NC)}
              ${kv(t('char_o_status'), agentLabel(c.status) || NC)}
              ${kv(t('char_o_skillbuff'), val(c.skills) + ' / ' + val(c.buffs))}
              ${kv(t('char_o_gcd'), missing('gcd_ms') ? NC : val(c.gcd_ms, 'ms'))}
              ${kv(t('char_o_updated'), App.fmt.rel(c.updated_at))}
              ${kv(t('char_o_adena'), c.adena == null ? NC : App.fmt.num(c.adena))}
            </div>
            <div class="kv-grid">
              <div class="kv-item"><div class="k">${esc(t('char_o_look'))}</div><div class="v sprv">${look}</div></div>
              <div class="kv-item"><div class="k">${esc(t('char_o_pk'))}</div><div class="v sprv">${pkHtml}</div></div>
            </div>
          </div>
          <div class="section">
            <div class="section-head"><h3>${esc(t('char_machine_hdr'))}</h3></div>
            <div class="kv-grid">
              ${kv(t('char_mc_name'), c.machine_label || c.machine || NC)}
              ${kv(t('char_mc_cpu_pct'), c.cpu_pct == null ? NC : Math.round(c.cpu_pct) + '%')}
              ${kv(t('char_mc_ram'), (c.ram_used_mb == null && mi.ram_total_mb == null) ? NC : (c.ram_used_mb == null ? NC : Math.round(c.ram_used_mb)) + ' / ' + val(mi.ram_total_mb) + ' MB')}
              ${kv(t('char_mc_os'), val(mi.os))}
              ${kv(t('char_mc_locale'), val(mi.locale))}
              ${kv(t('char_mc_cpu'), val(mi.cpu))}
              ${kv(t('char_mc_cores'), val(mi.cores))}
              ${kv(t('char_mc_ip'), val(mi.ip))}
            </div>
          </div>
          <div class="section">
            <div class="section-head"><h3>${esc(t('char_stats'))}</h3></div>
            ${statKeys.length ? `<div class="kv-grid">${statKeys.map(k => kv(k, stats[k])).join('')}</div>` : `<p class="muted">${esc(t('char_no_stats'))}</p>`}
          </div>
          <details class="panel diag">
            <summary>${esc(t('char_diag'))}</summary>
            <p class="small faint">${esc(t('char_diag_hint'))}</p>
            <div class="kv-grid">
              ${kv(t('char_o_ui'), uiList)}
              ${kv(t('char_o_scroll'), scrolls)}
              ${kv(t('char_o_slots'), slots)}
            </div>
            <div class="kv-item diag-occl"><div class="k">${esc(t('char_o_occl'))}</div><div class="v">${esc(occl)}</div></div>
          </details>`;
      }

      function tabEquipment(d, c, el) {
        const eq = c.equip || []; const inv = d.inventory || [];
        const rng = Number.isFinite(c.attack_range) ? c.attack_range : 0;
        const rngHtml = rng > 0 ? `<p class="small muted">${esc(t('char_eq_range', rng))}</p>` : '';
        if (!eq.length) { el.innerHTML = rngHtml + `<div class="empty-state"><p>${esc(t('char_eq_empty'))}</p></div>`; return; }
        el.innerHTML = rngHtml + `<p class="small muted">${esc(t('char_eq_count', eq.length))}</p><div class="invgrid">` + eq.map(e => {
          const m = inv.find(x => x && String(x.uid) === String(e.uid));
          const sty = m ? App.cat.itemIcon(m.code) : null;
          const nm = m ? App.cat.itemDisplay(m) : (e.name || ('#' + e.uid));
          return `<div class="invc" title="${esc('slot ' + e.slot + ' · ' + nm)}">${sty ? `<span class="ic" style="${sty}"></span>` : `<span class="ic noimg">${esc(String(nm).slice(0, 4))}</span>`}<span class="q">${esc(e.slot)}</span></div>`;
        }).join('') + `</div>`;
      }

      function renderInv(el, inv) {
        const host = el.querySelector('#invBody'); if (!host) return;
        if (!inv.length) { host.innerHTML = `<div class="empty-state"><p>${esc(t('char_no_inv'))}</p></div>`; return; }
        host.innerHTML = st.invMode === 'list' ? `<div class="invlist">${inv.map(invRow).join('')}</div>` : `<div class="invgrid">${inv.map(invCell).join('')}</div>`;
      }
      function tabInventory(d, c, el) {
        const inv = d.inventory || [];
        el.innerHTML = `<div class="toolbar between"><span class="small muted">${esc(t('char_inv_count', inv.length))}</span>
          <div class="seg" id="invSeg"><button type="button" data-m="image"${st.invMode === 'image' ? ' class="on"' : ''}>${esc(t('char_inv_image'))}</button><button type="button" data-m="list"${st.invMode === 'list' ? ' class="on"' : ''}>${esc(t('char_inv_list'))}</button></div></div>
          <div id="invBody"></div>`;
        renderInv(el, inv);
        el.querySelector('#invSeg').onclick = (e) => {
          const b = e.target.closest('button[data-m]'); if (!b) return;
          st.invMode = b.dataset.m; saveInvMode(st.invMode);
          el.querySelectorAll('#invSeg button').forEach(x => x.classList.toggle('on', x === b));
          renderInv(el, (st.data.inventory || []));
        };
      }

      function tabSkills(d, c, el) {
        const sl = d.skills_list || [];
        const cells = sl.map(e => {
          const sid = (e && typeof e === 'object') ? e.id : e; const sty = App.cat.skillIcon(sid); const nm = App.cat.skill(sid);
          const cd = (e && typeof e === 'object' && e.cd) ? e.cd : 0;
          const ico = sty ? `<span style="${sty}"></span>` : esc(String(nm).slice(0, 4));
          return `<div class="invc" title="${esc(nm)}">${ico}${cd > 0 ? '<span class="q">' + esc(cd) + '</span>' : ''}</div>`;
        }).join('');
        const bl = d.buffs_list || [];
        const bchips = bl.map(b => {
          const o = (b && typeof b === 'object') ? b : { id: b };
          const sp = (o.sp != null && o.sp >= 0) ? o.sp : null;
          const spName = sp != null ? App.cat.skill(sp) : '#';
          const nm = spName.charAt(0) !== '#' ? spName : App.cat.buff(o.id);
          const sty = App.cat.spellIconFrame(o.id, 22) || (sp != null ? App.cat.skillIcon(sp, 22) : null);
          const show = (typeof o.show === 'number' && o.show >= 0) ? o.show : null;
          const rem = show === null ? (o.inf ? ' ∞' : (o.remain > 0 ? ' ' + App.fmt.remain(o.remain) : ''))
            : show === 1 ? (o.remain > 0 ? ' ' + App.fmt.remain(o.remain) : '') : (show === 0 || show === 2) ? ' --' : '';
          const tip = [nm, (o.inf ? t('char_buff_inf') : (o.dur > 0 ? t('char_buff_dur', App.fmt.remain(o.dur)) : '')), App.cat.spellDesc(sp)].filter(Boolean).join('\n');
          return `<span class="buffchip" title="${esc(tip)}">${sty ? `<span class="bico" style="${sty}"></span>` : ''}${esc(nm)}<b class="brem">${esc(rem)}</b></span>`;
        }).join('');
        const qk = (c.quick && Array.isArray(c.quick.slots)) ? c.quick : null;
        const inv = d.inventory || [];
        const qcells = qk ? qk.slots.map(q => {
          let sty = null, nm = '';
          if (q.t === 1) { sty = App.cat.skillIcon(q.id, 34); nm = App.cat.skill(q.id); }
          else if (q.t === 2) { const it = inv.find(x => x && String(x.uid) === String(q.id)); if (it) { sty = App.cat.itemIcon(it.code); nm = App.cat.itemDisplay(it); } else nm = t('char_qs_item') + ' #' + q.id; }
          else nm = t('char_qs_behavior') + ' ' + q.id;
          const pos = (q.s % 8) + 1;
          return `<div class="invc${q.inv ? ' qinv' : ''}" title="${esc(nm)}">${sty ? `<span style="${sty}"></span>` : esc(String(nm).slice(0, 4))}<span class="q">${pos}</span></div>`;
        }).join('') : '';
        el.innerHTML = `<div class="section"><h3>${esc(t('char_skills_hdr', c.skills || 0, c.buffs || 0))}</h3>${sl.length ? `<div class="invgrid">${cells}</div>` : `<p class="muted">${esc(t('char_skills_note'))}</p>`}</div>
          <div class="section"><h3>${esc(t('char_qs_hdr', qk ? qk.page + 1 : '-', qk ? qk.slots.length : 0))}</h3>${qk && qk.slots.length ? `<div class="invgrid">${qcells}</div>` : `<p class="muted">${esc(t('char_qs_note'))}</p>`}</div>
          <div class="section"><h3>${esc(t('char_buffs_hdr', c.buffs || 0))}</h3>${bl.length ? `<div class="buffwrap">${bchips}</div>` : `<p class="muted">${esc(t('char_buffs_note'))}</p>`}</div>`;
      }

      // ── map rendering (gridmap schematic / isometric raster; player-centred) ──
      function gridImg(mapId) {
        if (!st.gridImgs[mapId]) { const img = new Image(); img.onload = () => { if (!st.destroyed && st.tab === 'map') renderMap(); }; img.src = App.cat.asset('gridmap/' + mapId + '.png', 'gridmap'); st.gridImgs[mapId] = img; }
        return st.gridImgs[mapId];
      }
      function isoImg(mapId) {
        if (!st.isoImgs[mapId]) { const img = new Image(); img.onload = () => { if (!st.destroyed && st.tab === 'map') renderMap(); }; img.src = App.cat.asset('isomap/' + mapId + '.png', 'isomap'); st.isoImgs[mapId] = img; }
        return st.isoImgs[mapId];
      }
      function attachMapHover(cvs, hits) {
        cvs._hits = hits;
        if (cvs._hoverWired) return; cvs._hoverWired = true;
        const tip = () => document.getElementById('invtip');
        cvs.onmousemove = (e) => {
          const tp = tip(); if (!tp) return;
          const rect = cvs.getBoundingClientRect(); const fx = cvs.width / rect.width, fy = cvs.height / rect.height;
          const mx = (e.clientX - rect.left) * fx, my = (e.clientY - rect.top) * fy;
          let best = null, bd = 1e9; for (const h of (cvs._hits || [])) { const dd = (h.x - mx) * (h.x - mx) + (h.y - my) * (h.y - my); if (dd < bd) { bd = dd; best = h; } }
          if (best && bd <= 100) { tp.textContent = (best.atk_me ? '⚔ ' : '') + (best.sel ? '◎ ' : '') + (best.name || '-') + ' (' + kindLabel(best.kind) + ')' + (best.act ? ' · ' + best.act : '') + (best.tgt ? ' → ' + best.tgt : '') + (Array.isArray(best.dst) ? ' ⇢ (' + best.dst[0] + ',' + best.dst[1] + ')' : '') + (Array.isArray(best.nxt) ? ' › (' + best.nxt[0] + ',' + best.nxt[1] + ')' : ''); tp.style.display = 'block'; tp.style.left = Math.min(window.innerWidth - tp.offsetWidth - 8, e.clientX + 14) + 'px'; tp.style.top = (e.clientY + 16) + 'px'; }
          else tp.style.display = 'none';
        };
        cvs.onmouseleave = () => { const tp = tip(); if (tp) tp.style.display = 'none'; };
        cvs.onwheel = (e) => { e.preventDefault(); const z = st.mapZoom || 20; st.mapZoom = Math.max(2, Math.min(60, z * (e.deltaY > 0 ? 1.25 : 0.8))); renderMap(); };
      }
      function renderMap() {
        const d = st.data; if (!d) return; const c = d.character || {}; const near = d.nearby || [];
        if (c.map_id == null) return;
        const gm = App.cat.gridInfo(c.map_id); const gimg = gm ? gridImg(c.map_id) : null;
        const iso = App.cat.isoInfo(c.map_id); const iimg = iso ? isoImg(c.map_id) : null;
        const draw = (cvsId, span, withTags) => {
          const cvs = root.querySelector('#' + cvsId); if (!cvs) return; const g = cvs.getContext('2d');
          const W = cvs.width, H = cvs.height; g.clearRect(0, 0, W, H); g.fillStyle = '#05070a'; g.fillRect(0, 0, W, H);
          const cx = W / 2, cy = H / 2;
          let isoReady = iso && iimg && iimg.complete && iimg.naturalWidth;
          let isoPP = null;
          if (isoReady) {
            isoPP = [((c.x || 0) + (c.y || 0)) * 48 - iso.ox, -((c.x || 0) - (c.y || 0)) * 24 - 24 - iso.oy];
            if (isoPP[0] < 0 || isoPP[0] > iso.w || isoPP[1] < 0 || isoPP[1] > iso.h) isoReady = false;
          }
          let toCanvas, dotR;
          if (isoReady) {
            const scale = (W / 2) / (span * 48);
            const t2p = (tx, ty) => [(tx + ty) * 48 - iso.ox, -(tx - ty) * 24 - 24 - iso.oy];
            const pp = isoPP;
            g.imageSmoothingEnabled = true;
            g.drawImage(iimg, cx - pp[0] * scale, cy - pp[1] * scale, iso.w * scale, iso.h * scale);
            toCanvas = (ax, ay) => { const p = t2p(ax, ay); return [cx + (p[0] - pp[0]) * scale, cy + (p[1] - pp[1]) * scale]; };
            dotR = Math.max(1.5, 48 * scale / 2);
          } else {
            const sc = (W / 2) / span;
            if (gm && gimg && gimg.complete && gimg.naturalWidth) {
              const ppx = (c.x || 0) - gm.ox, ppy = (c.y || 0) - gm.oy;
              let sx = ppx - span, sy = ppy - span, sw = span * 2, sh = span * 2;
              const sX = W / sw, sY = H / sh; let dx = 0, dy = 0, dw = W, dh = H;
              if (sx < 0) { dx = -sx * sX; dw += sx * sX; sw += sx; sx = 0; }
              if (sy < 0) { dy = -sy * sY; dh += sy * sY; sh += sy; sy = 0; }
              if (sx + sw > gimg.naturalWidth) { const o = sx + sw - gimg.naturalWidth; dw -= o * sX; sw -= o; }
              if (sy + sh > gimg.naturalHeight) { const o = sy + sh - gimg.naturalHeight; dh -= o * sY; sh -= o; }
              g.imageSmoothingEnabled = false;
              if (sw > 0 && sh > 0 && dw > 0 && dh > 0) { try { g.drawImage(gimg, sx, sy, sw, sh, dx, dy, dw, dh); } catch (_) {} }
            } else {
              g.strokeStyle = '#141b2488'; g.lineWidth = 1; const step = W / 10;
              for (let i = 0; i <= 10; i++) { g.beginPath(); g.moveTo(i * step, 0); g.lineTo(i * step, H); g.stroke(); g.beginPath(); g.moveTo(0, i * step); g.lineTo(W, i * step); g.stroke(); }
            }
            toCanvas = (ax, ay) => [cx + (ax - (c.x || 0)) * sc, cy + (ay - (c.y || 0)) * sc];
            dotR = Math.max(1, sc / 2);
          }
          const hits = [];
          for (const a of near) {
            const p = toCanvas(a.x || 0, a.y || 0); const px = p[0], py = p[1];
            if (px < -dotR || px > W + dotR || py < -dotR || py > H + dotR) continue;
            g.fillStyle = ACTOR_COL[a.kind] || '#6e7681'; g.beginPath(); g.arc(px, py, dotR, 0, 7); g.fill();
            hits.push(Object.assign({}, a, { x: px, y: py, name: a.name || '', kind: a.kind }));
            if (withTags && a.name && (a.kind === 'player' || a.kind === 'user' || a.kind === 'npc' || a.kind === 'remoteplayer')) {
              g.fillStyle = '#e6edf3'; g.font = '10px sans-serif'; g.textAlign = 'center'; g.fillText(a.name, px, py - dotR - 2);
            }
          }
          g.strokeStyle = '#2f81f7'; g.lineWidth = 2; g.beginPath(); g.arc(cx, cy, Math.max(4, dotR), 0, 7); g.stroke();
          g.fillStyle = '#2f81f7'; g.beginPath(); g.arc(cx, cy, 2, 0, 7); g.fill();
          if (withTags) attachMapHover(cvs, hits);
        };
        draw('mapC', st.mapZoom || 20, true);
        draw('miniC', 100, false);
        const zl = root.querySelector('#mapZoomLbl'); if (zl) zl.textContent = t('char_map_tiles', Math.round(st.mapZoom || 20));
      }
      function tabMap(d, c, el) {
        if (c.map_id == null) { el.innerHTML = `<div class="empty-state"><p>${esc(t('char_map_none'))}</p></div>`; return; }
        el.innerHTML = `<div class="maprow">
          <div class="mapmain"><div class="small muted">${esc(t('char_map_centered'))} · ${esc(t('char_map_wheel'))} <b id="mapZoomLbl"></b></div><canvas id="mapC" width="440" height="360"></canvas></div>
          <div class="mapmini"><div class="small muted">${esc(t('char_minimap'))}</div><canvas id="miniC" width="150" height="150"></canvas></div>
        </div><p class="small faint">${esc(t('char_legend'))}</p>`;
        renderMap();
      }

      // ── control tab ──
      function renderAcks(el, acks) {
        const host = el.querySelector('#cmdAcks'); if (!host) return;
        const list = (acks || []).slice().reverse();
        host.innerHTML = list.length ? list.map(a => `<div class="cmd-ack"><span class="dot ${a.ok ? 'ok' : 'bad'}"></span><span class="mono">${esc(a.k)}${a.v != null && a.v !== '' ? '=' + esc(a.v) : ''}</span>${a.msg ? `<span class="muted small">${esc(a.msg)}</span>` : ''}</div>`).join('') : `<p class="muted">${esc(t('char_cmd_empty'))}</p>`;
      }
      async function onCmd(spec, confirmKind) {
        let key = spec, value = '';
        const i = spec.indexOf(':'); if (i >= 0) { key = spec.slice(0, i); value = spec.slice(i + 1); }
        if (confirmKind) {
          const ok = await App.confirm({ title: t('char_confirm_' + confirmKind + '_title'), message: t('char_confirm_' + confirmKind), confirm: t('confirm'), danger: true });
          if (!ok) return;
        }
        const r = await App.api('/api/characters/' + st.id + '/command', { method: 'POST', body: { key, value } });
        if (r.ok && r.data && r.data.ok) App.toast(t('char_cmd_sent', key + (value !== '' ? '=' + value : '')));
        else App.toast((r.data && r.data.err) ? App.errorText(r.data) : t('char_agent_offline'), 'error');
      }
      function tabControl(d, c, el) {
        const play = d.raw && d.raw.play;
        el.innerHTML = `
          <div class="banner warn">${esc(t('char_ctrl_disruptive_note'))}</div>
          <div class="section"><div class="section-head"><h3>${esc(t('char_ctrl_actions'))}</h3></div>
            <div class="ctrl-grid">
              <div class="ctrl-row"><span class="ctrl-label">${esc(t('char_ctrl_hunt'))}</span><button class="btn secondary sm" data-cmd="hunt:1">${esc(t('char_on'))}</button><button class="btn secondary sm" data-cmd="hunt:0">${esc(t('char_off'))}</button></div>
              <div class="ctrl-row"><span class="ctrl-label">${esc(t('char_ctrl_overlay'))}</span><button class="btn secondary sm" data-cmd="overlay:1">${esc(t('char_on'))}</button><button class="btn secondary sm" data-cmd="overlay:0">${esc(t('char_off'))}</button></div>
              <div class="ctrl-row"><button class="btn secondary" data-cmd="play_return" data-confirm="return">${esc(t('char_ctrl_return'))}</button><button class="btn danger" data-cmd="play_stop" data-confirm="stop">${esc(t('char_ctrl_stop'))}</button></div>
            </div>
          </div>
          <div class="section"><div class="section-head"><h3>${esc(t('char_ctrl_play_state'))}</h3></div>
            <pre class="mono play-state" id="playState">${esc(play ? JSON.stringify(play, null, 2) : t('char_ctrl_no_play'))}</pre></div>
          <div class="section"><div class="section-head"><h3>${esc(t('char_cmd_results'))}</h3></div>
            <div id="cmdAcks" class="cmd-acks"></div></div>`;
        renderAcks(el, c.cmd_ack);
        el.querySelectorAll('[data-cmd]').forEach(b => b.onclick = () => onCmd(b.dataset.cmd, b.dataset.confirm));
      }

      // ── hunt tab (delegates to HuntForm.mountSlotEditor) ──
      function tabHunt(d, el) {
        if (st.huntMount) return;               // mounted already this render — do not rebuild
        const slot = d.slot;
        if (!slot || slot.id == null) {
          el.innerHTML = `<div class="empty-state"><div class="empty-icon">🎯</div><p>${esc(t('char_hunt_no_slot'))}</p><a class="btn primary" href="#/machines">${esc(t('char_hunt_no_slot_cta'))}</a></div>`;
          return;
        }
        if (!window.HuntForm || typeof window.HuntForm.mountSlotEditor !== 'function') {
          el.innerHTML = `<div class="banner warn">⚠ <span>${esc(t('char_hunt_unavailable'))}</span></div>`;
          console.warn('[char] HuntForm.mountSlotEditor unavailable; slot editor would mount for slot', slot.id);
          return;
        }
        el.innerHTML = `<div id="huntMount"></div>`;
        st.huntMount = window.HuntForm.mountSlotEditor(el.querySelector('#huntMount'), {
          slotId: slot.id,
          live: () => { const cc = st.data && st.data.character; return cc && cc.map_id != null ? { map_id: cc.map_id, x: cc.x, y: cc.y } : null; },
          onSaved: () => {}
        });
      }

      // ── body dispatch ──
      function drawBody() {
        const d = st.data; if (!d) return;
        const c = d.character || {};
        if (st.tab === 'hunt') { tabHunt(d, bodyEl); return; }
        if (st.huntMount) { try { st.huntMount.destroy(); } catch (_) {} st.huntMount = null; }
        if (st.tab === 'overview') tabOverview(d, c, bodyEl);
        else if (st.tab === 'inventory') tabInventory(d, c, bodyEl);
        else if (st.tab === 'equipment') tabEquipment(d, c, bodyEl);
        else if (st.tab === 'skills') tabSkills(d, c, bodyEl);
        else if (st.tab === 'map') tabMap(d, c, bodyEl);
        else if (st.tab === 'control') tabControl(d, c, bodyEl);
      }

      // ── live apply ──
      function applyLive(s) {
        if (!st.data) return;
        const c = st.data.character || (st.data.character = {});
        Object.assign(c, s);
        if (s.nearby_json) try { st.data.nearby = JSON.parse(s.nearby_json); } catch (_) {}
        if (s.inventory_json) try { st.data.inventory = JSON.parse(s.inventory_json); } catch (_) {}
        if (s.skills_json) try { st.data.skills_list = JSON.parse(s.skills_json); } catch (_) {}
        if (s.buffs_json) try { st.data.buffs_list = JSON.parse(s.buffs_json); } catch (_) {}
        if (s.stats_json) try { st.data.stats = JSON.parse(s.stats_json); } catch (_) {}
        if (s.raw_json) try { st.data.raw = JSON.parse(s.raw_json); } catch (_) {}
        detailCache.set(st.id, st.data);
        drawHeader();
        const tab = st.tab;
        if (tab === 'overview') drawBody();
        else if (tab === 'inventory') { if (s.inventory_json) drawBody(); }
        else if (tab === 'skills') { if (s.skills_json || s.buffs_json || s.quick || s.skills != null || s.buffs != null) drawBody(); }
        else if (tab === 'equipment') { if (s.equip || s.inventory_json) drawBody(); }
        else if (tab === 'map') renderMap();
        else if (tab === 'control') {
          renderAcks(bodyEl, c.cmd_ack);
          const ps = bodyEl.querySelector('#playState');
          if (ps) { const play = st.data.raw && st.data.raw.play; ps.textContent = play ? JSON.stringify(play, null, 2) : t('char_ctrl_no_play'); }
        }
      }

      async function fetchDetail() {
        const r = await App.api('/api/characters/' + st.id);
        if (st.destroyed) return;
        if (!r.ok) {
          if (!st.data) bodyEl.innerHTML = `<div class="empty-state"><div class="empty-icon">⚠</div><p>${esc(r.status === 404 ? t('char_not_found') : t('char_load_fail'))}</p><a class="btn secondary" href="#/">${esc(t('nav_dashboard'))}</a></div>`;
          else App.toast(App.errorText(r.data), 'error');
          return;
        }
        st.data = r.data; detailCache.set(st.id, r.data);
        drawHeader(); drawBody();
      }

      // ── boot ──
      if (st.data) { drawHeader(); drawBody(); } else { headerSkeleton(); bodySkeleton(); }
      fetchDetail();

      const offStates = App.ws.on('states', (m) => { for (const s of (m.states || [])) if (s.character_id === st.id) applyLive(s); });
      App.ws.subscribe([st.id]);

      return () => {
        st.destroyed = true;
        offStates();
        if (st.huntMount) { try { st.huntMount.destroy(); } catch (_) {} st.huntMount = null; }
      };
    }
  });
})();
